import styles from './style/Modal.module.scss';

const Modal = ({ isOpen, children, size, height, width, maxHeight }) => {
  // 傳入 maxHeight 時，將內容框改為「限高 + 內部捲動」的 flex column（xxl 預設沒有此設定）。
  const capped = !!maxHeight;
  return (
    <div id='myModal' className={isOpen ? styles.modalOpen : styles.modal}>
      <div
        className={
          size === 'xxl'
            ? styles.modalContentXXl
            : size === 'xl'
            ? styles.modalContentXl
            : size === 'lg'
            ? styles.modalContentLg
            : size === 'md'
            ? styles.modalContentMd
            : styles.modalContentSm
        }
        style={{
          height: height ? height : '',
          width: width ? width : '',
          ...(capped
            ? {
                maxHeight,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                overflow: 'hidden',
              }
            : {}),
        }}
      >
        <div
          style={
            capped
              ? {
                  flex: '1 1 auto',
                  minHeight: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                }
              : undefined
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
